import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { NotificationService, NotificationType } from 'src/app/shared/notification.service';
import { TimerService } from 'src/app/shared/timer/timer.service';
import {LoginService} from './login.service';
import {OtpDeliveryMethod, LoginStep} from './login.model';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
  providers: [LoginService]
})

export class LoginComponent implements OnInit {
  readonly step$ = this.loginService.step$;
  readonly isLoading$ = this.loginService.isLoading$;
  readonly loadingTip$ = this.loginService.loadingTip$;
  readonly otpDeliveryMethod$ = this.loginService.otpDeliveryMethod$;
  readonly selectedOtpDeliveryMethod$ = this.loginService.selectedOtpDeliveryMethod$;

  readonly LoginStep = LoginStep;


  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    public timerService: TimerService,
  ) { }

  ngOnInit(): void {
    combineLatest([this.route.paramMap, this.route.queryParamMap])
      .subscribe(([pathParams, queryParams]) => {
        if (queryParams.get('notify_ok')) {
          this.notificationService.createNotification(
            NotificationType.SUCCESS,
            'Successo',
            'Operazione effettuata con successo.'
          );
        }
        if (queryParams.get('notify_error')) {
          this.notificationService.createNotification(
            NotificationType.ERROR,
            'Errore',
            'Operazione non riuscita.'
          );
        }
      });
  }

  onLogin = (username: string, password: string) => this.loginService.onLogin(username, password);
  onClickCard = (level2RecognitionType: OtpDeliveryMethod) => this.loginService.onClickCard(level2RecognitionType);

  onLoginWithOtp = (otp: string, otpGenerator: OtpDeliveryMethod) => this.loginService.onLoginWithOtp(otp, otpGenerator);

  onBack($event: LoginStep): void {
    this.loginService.step = $event;
  }
}
